import React from 'react'
import { PayoutType } from './payoutTypes'
import WarningIcon from '../../../icons/WarningIcon'
interface IWarningBoxProps {
  payoutType: PayoutType
}
const WarningBox = ({ payoutType }: IWarningBoxProps): JSX.Element => {
  return (
    <div style={{
      padding: '14px 16px',
      display: 'flex',
      gap: 12,
      alignItems: 'flex-start',
      border: `1px solid ${payoutType === PayoutType.Crypto ? '#f1ddba' : '#dde2ea'}`,
      borderRadius: 14,
      background: payoutType === PayoutType.Crypto ? '#fff8ef' : '#f8fafc'
    }}>
      <div style={{ flexShrink: 0 }}>
        <WarningIcon stroke={payoutType === PayoutType.Crypto ? '#8B6914' : '#5b6474' } />
      </div>
      <span
        style={{
          flexShrink: 1,
          color: payoutType === PayoutType.Crypto ? '#8B6914' : '#5b6474',
          fontSize: 13.5,
          lineHeight: 1.5,
          fontWeight: 400
        }}>
        {payoutType === PayoutType.Crypto ? 'Please verify the recipient address carefully. Cryptocurrency transactions cannot be reversed.' : 'SEPA payouts over €100,000 may take 1-2 business days to arrive.'}
      </span>
    </div>
  )
}

export default WarningBox
